<app-popin-container bgColor="GRAY">
  @let p = priceDetail();
  @if (p) {
    @if (p.title; as title) {
      <div class="title-h1 pb-5 desk:p-12">{{ title }}</div>
    }
    <div class="gap-x-9 overflow-auto desk:grid desk:grid-cols-2 desk:px-12">
      <div>
        @if (p.image; as image) {
          <div class="mb-5 h-[228px] overflow-hidden rounded-3xl desk:h-[400px]">
            <app-image [image]="image" [isPriority]="true" />
          </div>
        }
        <div class="flex justify-between gap-x-3 pb-5">
          <div class="shrink">{{ p.ifClauses }}</div>
          <div class="flex flex-col justify-center gap-y-2">
            <span class="text-nowrap text-end font-title text-[40px]">{{ p.price }}</span>
            @if (p.ecoPart) {
              <span class="text-nowrap text-end text-[10px]">
                {{ "GLOBAL.INCLUDING_ECO_PART" | translate: { price: p.ecoPart } }}
              </span>
            }
          </div>
        </div>
      </div>
      <div>
        <div class="flex gap-x-3 pb-2.5">
          <span
            class="flex cursor-pointer rounded-[10px] border-2 px-4 py-3"
            [ngClass]="{ 'bg-anis': showKitchen() }"
            (click)="showKitchen.set(true)">
            {{ "GLOBAL.KITCHEN" | translate }}
          </span>
          <span
            class="flex cursor-pointer rounded-[10px] border-2 px-4 py-3"
            [ngClass]="{ 'bg-anis': !showKitchen() }"
            (click)="showKitchen.set(false)">
            {{ "GLOBAL.FINISHES" | translate }}
          </span>
        </div>
        <div class="rounded-xl bg-white p-3">
          @if (showKitchen()) {
            <div class="flex flex-col gap-y-5 overflow-auto desk:max-h-[380px]">
              <div class="font-bold">{{ p.priceDate }}</div>
              @for (item of p.items; track index; let index = $index) {
                <div class="flex flex-col gap-y-1">
                  <div class="font-bold">{{ item.description }}</div>
                  <div class="flex items-baseline gap-x-1.5 font-medium">
                    <span>Qté {{ item.quantity }} - {{ item.price }}</span>
                    @if (item.ecoPart) {
                      <span class="text-[10px]">
                        {{ "GLOBAL.INCLUDING_ECO_PART" | translate: { price: item.ecoPart } }}
                      </span>
                    }
                  </div>
                </div>
              }
            </div>
          } @else {
            <div [innerHTML]="p.finishes"></div>
          }
        </div>
      </div>
    </div>
  } @else {
    <div class="flex items-center justify-center py-10">
      <app-loader [text]="'COMPONENT.POPIN-PRICE-DETAIL.LOADING_PRICE_DETAILS' | translate" />
    </div>
  }
</app-popin-container>
